import { all } from 'redux-saga/effects';
import postalOperatorsWatcher from './PostalOperatorsSaga';

function* postalOperatorsMailboxSaga() {
  yield all([
    postalOperatorsWatcher(),
  ]);
}

export default postalOperatorsMailboxSaga;
